export const FEATURE_FLAGS = {
  BILLING: {
    ENABLED: 'billing_enabled',
    INVOICEPREVIEW_ENABLED: 'billing_invoicepreview_enabled'
  },
  LEIHBAR: {
    ENABLED: 'leihbar_enabled',
    STATISTICS_ENABLED: 'leihbar_statistics_enabled'
  },
  POLYAS: {
    ENABLED: 'polyas_enabled'
  },
  GLOBAL: {
    SENTRYFEEDBACKBUTTON_ENABLED: 'global_sentryfeedbackbutton_enabled'
  }
} as const;
